export default __webpack_public_path__ + "static/media/cn1.da10cb6b.jpg";